import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Button } from '@storable/canaveral-components';

const propTypes = {
  undoDisabled: PropTypes.bool.isRequired,
  redoDisabled: PropTypes.bool.isRequired,
  previousVersionPath: PropTypes.string,
  nextVersionPath: PropTypes.string,
};

const defaultProps = {
  previousVersionPath: undefined,
  nextVersionPath: undefined,
};

const UndoRedoButtons = ({
  undoDisabled,
  redoDisabled,
  previousVersionPath,
  nextVersionPath,
}) => (
  <React.Fragment>
    <Button
      inverted
      size="sm"
      borderless
      icon="undo"
      label="Undo"
      shape="circle"
      context="subtle"
      disabled={!!undoDisabled}
      componentClass={Link}
      to={previousVersionPath}
    />
    <Button
      inverted
      size="sm"
      borderless
      icon="redo"
      label="Redo"
      shape="circle"
      context="subtle"
      disabled={!!redoDisabled}
      componentClass={Link}
      to={nextVersionPath}
    />
  </React.Fragment>
);

UndoRedoButtons.propTypes = propTypes;
UndoRedoButtons.defaultProps = defaultProps;

export default UndoRedoButtons;
